import { api } from './client';

export interface ReminderDto {
  id: string;
  siteId: string;
  patientId: string;
  patientName: string;
  patientPhone: string;
  budgetId: string | null;
  budgetNumber: string | null;
  treatmentName: string | null;
  pendingAmount: number | null;
  templateId: string | null;
  templateName: string | null;
  customMessage: string | null;
  resolvedMessage: string;
  scheduledDate: string;
  status: 'PENDIENTE' | 'ENVIADO' | 'FALLIDO' | 'CANCELADO';
  failReason: string | null;
  failReasonLabel: string | null;
  sentAt: string | null;
  appointmentOutcome: 'CITED' | 'NOT_CITED' | null;
  createdById: string;
  createdByName: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateReminderRequest {
  patientId: string;
  budgetId?: string;
  templateId?: string;
  customMessage?: string;
  scheduledDate: string;
}

export interface UpdateReminderRequest {
  templateId?: string;
  customMessage?: string;
  scheduledDate?: string;
}

export const remindersApi = {
  getAll: (params?: {
    status?: string; dateFrom?: string; dateTo?: string; patientId?: string; budgetId?: string;
  }): Promise<ReminderDto[]> => {
    const qs = new URLSearchParams();
    if (params?.status)    qs.set('status', params.status);
    if (params?.dateFrom)  qs.set('dateFrom', params.dateFrom);
    if (params?.dateTo)    qs.set('dateTo', params.dateTo);
    if (params?.patientId) qs.set('patientId', params.patientId);
    if (params?.budgetId) qs.set('budgetId', params.budgetId);
    const q = qs.toString();
    return api.get(`/reminders${q ? '?' + q : ''}`);
  },

  create: (data: CreateReminderRequest): Promise<ReminderDto> =>
    api.post('/reminders', data),

  update: (id: string, data: UpdateReminderRequest): Promise<ReminderDto> =>
    api.patch(`/reminders/${id}`, data),

  cancel: (id: string): Promise<ReminderDto> =>
    api.patch(`/reminders/${id}/cancel`),

  setOutcome: (id: string, outcome: 'CITED' | 'NOT_CITED'): Promise<ReminderDto> =>
    api.patch(`/reminders/${id}/outcome`, { outcome }),
};
